export class SaveFilter {
  static readonly type = '[Main] SaveFilter';
  constructor(public data: any) {}
}

export class SaveTotalReportState {
  static readonly type = '[Main] SaveTotalReportState';
  constructor(public totalReportState: any) {}
}

export class SaveBranchState {
  static readonly type = '[Main] SaveBranchState';
  constructor(public branchState: any) {}
}


export class SaveFilterState {
  static readonly type = '[Main] SaveFilterState';
  constructor(public filterState: any) {}
}

export class SaveQueryState {
  static readonly type = '[Main] SaveQueryState';
  constructor(public query: any) {}
}

export class SaveDataState {
  static readonly type = '[Main] SaveDataState';
  constructor(public data: any) {}
}

export class ResetData {
  static readonly type = '[Main] ResetData';
  constructor() {}
}
